import { NodeModel } from "@xanadu/model";

export class DragDrop {
    constructor(
        public readonly drag: NodeModel,
        public readonly dropId: string
    ) {
    }
}